import { normalSanatizerBRL } from "src/utils/functions";
import { ResultHorasExtras } from "../horas-extras";
export const HorasExtrasTable = ({
  results,
}: {
  results: ResultHorasExtras;
}) => {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">Horas Extras</th>
            <th className="px-4 py-2 text-center truncate">Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Salário base (bruto)
            </td>

            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.salarioBruto)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Total de horas extras normais
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.horasExtrasNormais)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Total de horas noturnas
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.horaNoturna)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Total de horas extras 100%
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.horaExtrasCem)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              VALOR BRUTO DE HORAS EXTRAS
            </td>

            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.valorFinal)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
